import { Form, Input, Button, Space, Message, Link } from '@arco-design/web-react'
import { IconLock, IconUser, IconEmail, IconUserAdd } from '@arco-design/web-react/icon'
import React, { useEffect, useState } from 'react'

import { registerApi } from '@/api/login'
import useLocale from '@/utils/useLocale'
import useAfterInformation from '@/hooks/useAfterOnboarding'
import useAfterLogin from '@/hooks/useAfterLogin'
import CustomInput from '@/components/CustomInput'
import styles from './style/index.module.less'
import { addEnhancedConversion, baiduRegisterEvent, emailFormValidator } from '@/utils'
import { clearInviteCode } from '@/utils/checkLogin'
import { getBdVid, getPromotionInfo } from '@/hooks/useBdVid'
import { gtagRegisterEvent } from '@/utils/gtagEvent'
import { useEmailCaptcha } from '@/hooks/useEmailCaptcha'

const initialValues = { email: '', password: '', invite_code: '' }

interface IProps {
  email?: string
  platform?: string
  sessionFlag?: string
  inviteCode?: string
  step?: string
  btns?: any[]
  isEffective?: boolean
  onChangeForm?: (v: 'email' | 'phone') => void
}

export default function LoginForm(props: IProps) {
  const { sessionFlag, inviteCode, step, btns, email, isEffective, platform, onChangeForm } = props || {}
  const promotionInfo = getPromotionInfo()
  const [form] = Form.useForm()

  const [loading, setLoading] = useState(false)

  const t = useLocale()
  const { afterRegisterSuccess } = useAfterInformation({ rememberPassword: false })

  const handleSignUpRes = (params, signUpRes) => {
    signUpRes
      .then((res) => {
        const { code } = res?.data || {}

        if (code === 0) {
          clearInviteCode()
          Message.success(t['register.form.result.successMsg'])
          // 增加百度统计，注册转化成功
          baiduRegisterEvent()
          gtagRegisterEvent()
          afterRegisterSuccess(params, res?.data)
        } else {
          console.log(code)
        }
      })
      .catch((err) => {
        console.log('err', err?.response)
        // 设置错误信息
        const { messages, email, password, invite_code } = err?.response?.data?.errors || {}
        if (messages) {
          Message.error(messages)
        }

        if (invite_code) {
          Message.error(invite_code?.[0])
        }

        form?.setFields({
          // 存在则展示，不存在不展示
          name: messages
            ? {
                value: params.name,
                error: {
                  message: messages
                }
              }
            : undefined,
          email: email?.[0]
            ? {
                value: params.email,
                error: {
                  message: email?.[0]
                }
              }
            : undefined,
          password: password?.[0]
            ? {
                value: params.password,
                error: {
                  message: password?.[0]
                }
              }
            : undefined,
          invite_code: invite_code?.[0]
            ? {
                value: params.invite_code,
                error: {
                  message: invite_code?.[0]
                }
              }
            : undefined
        })
      })
      .finally(() => {
        setLoading(false)
      })
  }

  const handleRegister = async (params) => {
    setLoading(true)
    const signUpRes = registerApi({
      ...params,
      ...promotionInfo
    })
    handleSignUpRes(params, signUpRes)
  }

  function onSubmitClick() {
    form
      ?.validate()
      .then((values) => {
        addEnhancedConversion(values?.email)
        handleRegister(values)
      })
      .catch((err) => {
        console.log(err)
      })
  }

  const { onCaptchaShow } = useEmailCaptcha(form, onSubmitClick)

  useEffect(() => {
    form?.setFieldValue('invite_code', inviteCode)
  }, [inviteCode])

  return (
    <div className={styles['login-form-wrapper']}>
      {/* <div className={styles['login-form-sub-title']}>{t['register.form.subTitle']}</div> */}
      <Form form={form} className={styles['login-form']} layout="vertical" initialValues={initialValues}>
        <Form.Item
          label={t['register.form.email.label']}
          field="email"
          rules={[
            {
              required: true,
              validator: emailFormValidator,
              message: t['login.form.email.errMsg']
            }
          ]}
          initialValue={email || ''}
        >
          <CustomInput type="email" placeholder={t['register.form.email.placeholder']} disabled={!!email?.trim()} />
        </Form.Item>
        <Form.Item
          label={t['login.form.password.label']}
          field="password"
          rules={[{ required: true, message: t['login.form.password.errMsg'] }]}
        >
          <CustomInput type="password" placeholder={t['login.form.password.placeholder']} />
        </Form.Item>
        <Form.Item
          label={t['register.form.invite.label']}
          field="invite_code"
          rules={[{ required: false, message: t['login.form.invite.errMsg'] }]}
          // 邀请码逻辑仍然保留，但是不再展示
          // 2024.05.22 继续展示邀请码
          // style={{ display: 'none' }}
        >
          <CustomInput type="text" placeholder={t['register.form.invite.placeholder']} />
        </Form.Item>
        <Space size={16} direction="vertical" style={{ marginTop: 0 }}>
          <span className={styles.emailLogin} onClick={() => onChangeForm?.('phone')}>
            {t['phone_register']}
          </span>
          <Button
            type="primary"
            id="captcha-button"
            long
            onClick={onCaptchaShow}
            loading={loading}
            className={styles['login-form-btn']}
          >
            {t['login.form.register']}
          </Button>
        </Space>
        <div className={styles['login-form-desc']}>
          {t['register.tips']}
          <a
            href="https://echotik.live/privacy-policy.html"
            target="_blank"
            rel="noreferrer"
            className={styles['checkbox-protocol']}
          >
            {t['register.service']}
          </a>
          {t['register.and']}
          <a
            href="https://echotik.live/privacy-policy.html"
            target="_blank"
            rel="noreferrer"
            className={styles['checkbox-protocol']}
          >
            {t['register.privacy']}
          </a>
        </div>
      </Form>
    </div>
  )
}
